$(document).ready(function () {
	//Ajax
	//   $('.text-link').click(function() {
	//     location.reload();
	//   });
	//Ajax end


	$("body").on("click", ".blog-tabs li", function (event) {
		$(".blog-tabs").css("pointer-events", "none");
		//       $(".loader_image").fadeIn(300);
		$(this).parent().find(".active").removeClass("active");
		$(this).addClass("active");
		event.preventDefault();

		var ajax_url = $(this).find("a").data("href");
		if (history.pushState) {
			history.pushState({ url: ajax_url }, ajax_url, ajax_url);
		}
		$(".blog-main-section").load(" .main-data");
		setTimeout(function () {
			$(".blog-tabs").css("pointer-events", "all");
			//        $(".loader_image").css("display","none");
		}, 100);
		return false;
	});
	$(".info-popup-icon").click(function () {
		$(".productpoupnew").addClass("active");
		$("body").addClass("fixed-popup");
	});

	var mobileAccountNavigation = document.querySelector("#mob_dropdown_acc");
	if (mobileAccountNavigation) {
		var mobileAccountOptions = [].slice.call(
			document.querySelector("#mob_dropdown_acc").options
		);
		var pagePath = window.location.href.split("fatty15.com")[1];
		mobileAccountOptions.forEach(function (option) {
			if (pagePath !== option.value) return;
			option.selected = true;
		});
	}



	$("#mob_dropdown_acc").on("change", function () {
		var location = $("option:selected", this).attr("value");
		if (window.location.href === location) return
		window.location.href = "https://fatty15.com" + location;
	});
});

$(".closemodalpro").click(function () {
	$(".productpoupnew").removeClass("active");
	$("body").removeClass("fixed-popup");
});

var science = [];
$(".scienceaniamtion").each(function (eeee, ssss) {
	var iiii = $(ssss).attr("class").split(" ")[0];
	(iiii = bodymovin.loadAnimation({
		container: ssss,
		renderer: "svg",
		loop: true,
		autoplay: true,
		path: $(ssss).attr("image-url"),
	})),
		science.push(iiii);
});

$(window).bind("load", function () {
	if (document.readyState === "complete") {
		setTimeout(function () {
			jQuery(".loader").fadeOut(100);
		}, 0);
	}
	/* AOS */
	setTimeout(function () {
      	AOS.init({
			duration: 1000,
			offset: 150,
			once: true,
		});
    }, 200);
});

$(document).ready(function () {
	$(".our-way-tabs ul li a").on("mouseenter", function () {
		$(this).parent("li").removeClass("active");
		$(".our-way-tabs ul li").addClass("active");
	});
	$(".our-way-tabs ul li a").on("mouseleave", function () {
		$(this).parent("li").removeClass("active");
		$(".our-way-tabs ul li").removeClass("active");
	});


  /*-----
  Animate numbers (omega page)
  ------*/

   function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const counters = document.querySelectorAll('[data-js-counter]');

  if (counters) {
    var flag = true;
    var scroll = $(window).scrollTop();
    counters.forEach(function(counter) {
      if (scroll > counter.offsetTop - 100) {
        animateValue(counter, 0, counter.dataset.jsCounter, 3000);
        flag = false;
      }
    });

    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(flag) {
         counters.forEach(function(counter) {
           if (scroll > counter.offsetTop - 100) {
             animateValue(counter, 0, counter.dataset.jsCounter, 3000);
           	 flag = false;
           }
         });
      }
  	});
  }

    function animateLoop(text1, text2){
        $("[data-js-animate-loop]").delay(2000).animate(
            {opacity:0 },function(){
                $(this).text('cells').animate({opacity:1},function(){
                    $(this).delay(2000).animate({opacity:0},function(){
                        $(this).text('self').animate({opacity:1}, function(){
                            animateLoop();
                        });
                    });
                });

            });
    }

  var text1 = $("[data-js-animate-loop]").text();
  var text2 = $("[data-js-animate-loop]").data('js-animate-loop');
  var text3 = $("[data-js-animate-loop-third]").data('js-animate-loop-third');
  var text4 = $("[data-js-animate-loop-fourth]").data('js-animate-loop-fourth');

  animateLoop(text1, text2, text3, text4);

  var waterfallContainer = document.querySelector('.tt__tiles-columns');
  if (waterfallContainer) {
    waterfall('.tt__tiles-columns');

    setTimeout(function() {
        waterfall('.tt__tiles-columns');
    }, 1000);

    $(window).on('resize', function(){
      waterfall('.tt__tiles-columns');
    });
  }
});

/**
 * Helpers
 */
/**
 *  get parameter from Url
 * @param sParam
 * @returns {*}
 */
function getURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');

    for (let i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1];
        }
    }

    return false;
}

$(document).ready(function () {
  	// swiper
	var modalThumb = new Swiper(".modalthumb", {
		spaceBetween: 0,
		slidesPerView: 1,
      	centeredSlides: true,
		navigation: {
			nextEl: ".swiper-button-next2",
			prevEl: ".swiper-button-prev2",
		},
		//      initialSlide:2,
	});
	var swiperSlider = new Swiper(".teamsliderrr", {
		slidesPerView: "auto",
		spaceBetween: 30,
		speed: 1000,
		centeredSlides: true,
		slideToClickedSlide: true,
		freeMode: false,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			300: {
				centeredSlides: true,
			},
			768: {
				centeredSlides: false,
			},
		},
	});
	// swiperSlider.controller.control = modalThumb;
	//     modalThumb.controller.control = swiperSlider;

  	// Get paramter form URL and display person
  	var personParameter =  getURLParameter('person');
  	if (personParameter) {
      	$("html, body").animate({ scrollTop: $('.team-slider').offset().top }, 1000);
        var numberPage = $('[data-js-person="'+ personParameter +'"]').attr('ref-div');
     	$(".modal-slider-team").addClass("active");
		$("body").addClass("fixed-popup");
		$(".swiperlsidepost").addClass("add");
        new Swiper(".modalthumb").slideTo(numberPage, 1000, false);
    }

	function goToPage(numberPage) {
		new Swiper(".modalthumb").slideTo(numberPage, 1000, false);
	}

	if ($(window).width() > 767) {
		$(".team-slider-inner .swiper-wrapper").prepend(
			$(".team-slider .custom-text-box.custom-text-box-up")
		);
	}
	// swiper.on('slideChange', function () {
	//   $(".team-slider .custom-text-box").addClass("active");
	//    TweenMax.to('.team-slider .custom-text-box', .2, {
	//    autoAlpha: 0
	//   })
	// })

	// $('.modal-slider-team-inner .swiper-wrapper').prepend( $('.modal-slider-team-inner .swiperlsidepost') );

	$(".teamsliderrr [data-js-person]").click(function () {
		$(".modal-slider-team").addClass("active");
		$("body").addClass("fixed-popup");
		$(".swiperlsidepost").addClass("add");
		var page = $(this).attr("ref-div");
		goToPage(page);
	});
	$(".modal-slider-team a.close").click(function () {
		$(".modal-slider-team").removeClass("active");
		$("body").removeClass("fixed-popup");
	});

	$(".btn.address-new-toggle,.address-edit-toggle").click(function () {
		$("body").addClass("fixed-popup");
	});
	$(".text-link.address-new-toggle").click(function () {
		$("body").removeClass("fixed-popup");
	});
});

$(document).ready(function () {
	if ($(window).width() < 992) {
		$(".yes-section").attr("data-jarallax-element", "50");
	}
});

$(window).scroll(function () {
	if ($(window).scrollTop() >= 30) {
		$(".header-website").addClass("fixed-header2");
	}
	//     if ($(window).scrollTop() >= 120) {
	//           $('.header-website').addClass('fixed-header');
	//      }
	else {
		//         $('.header-website').removeClass('fixed-header');
		$(".header-website").removeClass("fixed-header2");
	}
});
$(window).scroll(function () {
	if ($(window).scrollTop() >= 120) {
		$(".header-website").addClass("fixed-header");
	} else {
		$(".header-website").removeClass("fixed-header");
	}
});

// toggle icon
$(".hamburguremenu").click(function () {
	$(this).toggleClass("toggle");
	$(".header-website .navigation").toggleClass("active");
	$(".header-website").toggleClass("fixed-header-hamb");
});

//    container
var $bodyWidth = $(window).width();
var $containerWidth = $(".container").width();
var $containerWidth2 = $(".container").width();
var $getWidth = ($bodyWidth - $containerWidth) / 2;
var $getWidth2 = ($bodyWidth - $containerWidth2) / 2;
$(".padding-right-container").css("padding-right", $getWidth + "px");
$(".padding-left-container").css("padding-left", $getWidth2 + "px");

$(document).ready(function () {
	var slider = $(".testimonials-img-slider").slick({
		arrows: false,
		infinite: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		asNavFor: ".testimonials-content-slider",
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					dots: true,
				},
			},
		],
	});
	var sliderdirtyone = $(".dirty-slider-wrap-slider").slick({
		arrows: false,
		infinite: false,
		dots: false,
		slidesToShow: 5,
		slidesToScroll: 5,
		focusOnSelect: true,
		autoplay: false,
		//     prevArrow:'.leftarrow',
		//     nextArrow:'.rightarrow',
		asNavFor: ".dirty-slider-wrap-slider2",
		responsive: [
			{
				breakpoint: 767,
				settings: {
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});
	var sliderdirtytwo = $(".dirty-slider-wrap-slider2").slick({
		arrows: true,
		infinite: false,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		prevArrow: ".leftarrow",
		nextArrow: ".rightarrow",
		asNavFor: ".dirty-slider-wrap-slider",
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					dots: false,
				},
			},
		],
	});

	$(".product-new-banner-slider").slick({
		arrows: true,
		infinite: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		variableWidth: true,
		prevArrow: ".newprevarrowbtn",
		nextArrow: ".newnextarrowbtn",
		responsive: [
			{
				breakpoint: 769,
				settings: {
					arrows: false,
				},
			},
		],
	});

	var slider2 = $(".testimonials-content-slider").slick({
		arrows: false,
		infinite: true,
		dots: true,
		slidesToShow: 1,
		autoplaySpeed: 5000,
		slidesToScroll: 1,
		draggable: false,
		autoplay: true,
		asNavFor: ".testimonials-img-slider",
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					dots: false,
				},
			},
		],
	});

	$(".green-section-slider").slick({
		speed: 1000,
		autoplay: true,
		dots: false,
		arrows: false,
		autoplaySpeed: 3000,
		fade: true,
		slidesToShow: 1,
		draggable: true,
		asNavFor: ".greenclientlogos ul",
		infinite: true,
	});
	$(".greenclientlogos ul").slick({
		speed: 1000,
		autoplay: false,
		dots: false,
		arrows: true,
		prevArrow: ".greenclientlogosleftarrow",
		nextArrow: ".greenclientlogosrightarrow",
		autoplaySpeed: 3000,
		focusOnSelect: true,
		slidesToShow: 3,
		centerMode: true,
		//    slidesPerRow: 4,
		slidesToScroll: 1,
		asNavFor: ".green-section-slider",
		infinite: true,
		swipeToSlide: true,
		//   rows: 2,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					centerMode: true,
					centerPadding: '50px',
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	// blog slider

	$(".banner-blog-slider").slick({
		arrows: false,
		infinite: true,
		dots: true,
		speed: 4500,
		slidesToShow: 1,
		slidesToScroll: 1,
		draggable: true,
		fade: true,
		autoplay: true,
	});

	$(".cells-armor-slider").slick({
		speed: 4000,
		autoplay: true,
		dots: false,
		arrows: false,
		variableWidth: true,
		autoplaySpeed: 0,
		cssEase: "linear",

		draggable: true,
		infinite: true,
		centerMode: false,
	});
	$(".continuous").slick({
		speed: 3200,
		autoplay: true,
		dots: false,
		arrows: false,
		autoplaySpeed: 0,
		cssEase: "linear",
		slidesToShow: 8,
		draggable: false,
		infinite: true,
		centerMode: true,
		vertical: true,
		verticalSwiping: true,

		responsive: [
			{
				breakpoint: 767,
				settings: "unslick",
			},
		],
	});
});

var $comparisonSlider = $(".comparison-slider-container"),
	$sliderLeft = $comparisonSlider.find(".slider-left"),
	$handle = $comparisonSlider.find(".handle"),
	$caption = $comparisonSlider.find(".slider-caption"),
	$captionLeft = $comparisonSlider.find(".slider-caption-left"),
	$captionRight = $comparisonSlider.find(".slider-caption-right"),
	$comparisonSliderWidth = $comparisonSlider.width(),
	$comparisonSliderHeight = $comparisonSlider.height(),
	$startPosition = ($comparisonSliderWidth / 100) * 50,
	$btnExpandLeft = $(".btn-expand-left"),
	$btnExpandCenter = $(".btn-expand-center"),
	$btnExpandRight = $(".btn-expand-right"),
	tl = new TimelineMax({ delay: 1 });

// set initial positioning

// tween
tl.set($caption, { autoAlpha: 0, yPercent: -100 }, 0);
tl.to(
	$sliderLeft,
	0.7,
	{ width: $startPosition, ease: Back.easeOut.config(1.7) },
	0
);
tl.to($handle, 0.7, { x: $startPosition, ease: Back.easeOut.config(1.7) }, 0);
tl.staggerTo(
	$caption,
	0.7,
	{ autoAlpha: 1, yPercent: 0, ease: Back.easeInOut.config(3) },
	-0.3,
	0
);

// draggable
Draggable.create($handle, {
	bounds: {
		minX: 0,
		minY: 0,
		maxX: $comparisonSliderWidth,
		maxY: $comparisonSliderHeight,
	},
	type: "x",
	edgeResistance: 1,
	throwProps: true,
	onDrag: onHandleDrag,
	onLockAxis: function () {
		var functionName = arguments.callee.name;
		
	},
});

function onHandleDrag() {
	console.log("drag", this);
	TweenMax.set($sliderLeft, { width: this.endX }, 0);

	// show/hide caption if you drag past the center of the container, towards left/right direction.
	if (this.endX >= this.maxX / 2 && this.getDirection() === "right") {
		showLeftCaption();
	}
	if (this.endX <= this.maxX / 2 && this.getDirection() === "left") {
		showRightCaption();
	}
}

function showLeftCaption() {
	TweenMax.to($captionLeft, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
	TweenMax.to($captionRight, 0.3, { autoAlpha: 0, yPercent: -100 }, 0);
}

function showRightCaption() {
	TweenMax.to($captionLeft, 0.3, { autoAlpha: 0, yPercent: -100 }, 0);
	TweenMax.to($captionRight, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
}

function showBothCaptions() {
	TweenMax.to($captionLeft, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
	TweenMax.to($captionRight, 0.3, { autoAlpha: 1, yPercent: 0 }, 0);
}

function slideHandleTo(_pos) {
	TweenMax.to(
		$sliderLeft,
		0.7,
		{ width: ($comparisonSliderWidth / 100) * _pos, ease: Power2.easeOut },
		0
	);
	TweenMax.to(
		$handle,
		0.7,
		{ x: ($comparisonSliderWidth / 100) * _pos, ease: Power2.easeOut },
		0
	);
}

// CLICK HANDLERS

$btnExpandLeft.on("click", function () {
	slideHandleTo(100);
	showLeftCaption();
});

$btnExpandCenter.on("click", function () {
	slideHandleTo(50);
	showBothCaptions();
});

$btnExpandRight.on("click", function () {
	slideHandleTo(0);
	showRightCaption();
});

// parrallax
// var controllers = new ScrollMagic.Controller();
// new ScrollMagic.Scene({
//   triggerElement: '#taleofipod',
//   triggerHook: 'onLeave',
// })
// .setPin('#taleofipod')
// .addTo(controllers);
// new ScrollMagic.Scene({
//   triggerElement: '#yessection',
//   triggerHook: 'onLeave',
// })
// .setPin('#yessection')
// .addTo(controllers);

$(".our-way-tabs ul li a,.faq-tabs ul li a,.scrollinquiry").on( "click", function (e) {
		var headerHeight = $("header").outerHeight();
		var headerHight2 = headerHeight + 30;
		var href = $(this).attr("href");

		console.log($(href))
		$("html, body").animate(
			{
				scrollTop: $(href).offset().top - headerHight2,
			},
			"1000"
		);

		e.preventDefault();
	}
);

// Capsule way animations
$(window).on("load", () => {
	let controller;
	let $window;
	let widthWidth;
	let textColumnHeight;
	let textContainerHeight;
	let textScene;
	let handHeight;
	let animationContainerHeight;
	let pillHeight;
	let tweenParams;
	let pillScene;

	const capsuleWayAnimations = () => {

		if (!document.querySelector('.capsule-way-pill-image')) return;

		controller = new ScrollMagic.Controller();

		$window = $(window);
		widthWidth = $window.width();

		// Text scene
		textColumnHeight = $(".capsule-way-text").height() - 320;
		textContainerHeight = $(".capsule-way-text-container").height() / 2;

		textScene = new ScrollMagic.Scene({
			triggerElement: ".capsule-way-text-wrapper",
			duration: textColumnHeight,
			offset: textContainerHeight,
		})
			.setPin(".capsule-way-text-container")
			.addTo(controller);

		// Pill scene
		handHeight = $(".capsule-way-hand").height();
		animationContainerHeight =
			$(".capsule-way-animation").height() - handHeight - 188;
		pillHeight = $(".capsule-way-pill-image").height();
		tweenParams = { scale: 0.225, rotate: "88deg", x: "-40px" };

		if (widthWidth < 1280 && widthWidth > 767) {
			tweenParams = {
				scale: 0.2,
				rotate: "88deg",
				x: "-40px",
				y: "-20px",
			};
		} else if (widthWidth < 767) {
			tweenParams = {
				scale: 0.17,
				rotate: "88deg",
				x: "-27px",
				y: "25px",
			};
		}

		pillScene = new ScrollMagic.Scene({
			triggerElement: ".capsule-way-pill",
			duration: animationContainerHeight,
			offset: pillHeight / 2,
		})
			.setPin(".capsule-way-pill-image")
			.setTween(".capsule-way-pill-image", tweenParams)
			.addTo(controller);
	};

	capsuleWayAnimations();

	$(window).on("resize", () => {
		if (!controller) return;
		controller.destroy(true);
		controller = null;
		scene = null;
		capsuleWayAnimations();
	});
});

ScrollTrigger.create({
	trigger: ".col-50-imginner .custom-img-box",
	start: "top top+=20%",
	endTrigger: ".spaceend2",
	end: "bottom bottom",
	pin: true,
	pinSpacing: false,
	scrub: 1,
});

ScrollTrigger.create({
	trigger: "#capsule",
	start: "top top+=20",
	endTrigger: ".capsule-way-box:nth-child(3) .custom-img-box",
	end: "bottom bottom+=1",
	pin: ".capsule-way-box:nth-child(1) .custom-img-box img",
	pinSpacing: true,
	scrub: 1,
});

// ScrollTrigger.create({
//   trigger: ".sticky-today",
//   start: "top bottom-=150",
//   endTrigger: ".today-content",
//   end: "top bottom-=75",
//   pin: true,
//   pinSpacing: false,
//   scrub: 1
// });

// ScrollTrigger.create({
//   trigger: ".capsule-way-box:nth-child(2) .custom-img-box",
//   start: "top top+=100",
//   endTrigger: ".capsule-way-box:nth-child(3) .custom-img-box",
//   end: "bottom bottom+=40",
//   pin: true,
//   pinSpacing: false,
//   scrub: 1
// });

// ScrollTrigger.create({
//   trigger: ".capsule-way-box:nth-child(3) .custom-img-box img",
//   start: "top top+=100",
//   endTrigger: ".animationoff",
//   end: "bottom bottom+=40",
//   pin: true,
//   pinSpacing: false,
//   scrub: 1
// });

$(document).ready(function () {
	var controllercap = new ScrollMagic.Controller();
	var timeline3 = new TimelineMax();
	timeline3.to(
		".capsule-way-box:nth-child(1) .custom-img-box img",
		4,
		{
			scale: 0.29,
			x: -40,
			rotate: 91,
			ease: Power3.easeInOut,
		},
		"-=4"
	);

	var scene3 = new ScrollMagic.Scene({
		triggerElement: "#capsule",
		duration: "100%",
		triggerHook: 0,
		offset: "20",
	})
		.setTween(timeline3)
		.setPin(".capsule-way-box:nth-child(3) .custom-img-box img")
		.reverse(true)
		.addTo(controllercap);
});

$(".science-health-tabs li a").click(function () {
	AOS.refresh();
	var tab_id = $(this).attr("data-tab");
	$(".science-health-tabs li a").removeClass("active");
	$(".tab-content-wrap .tab-content").removeClass("active");
	$(this).addClass("active");
	$("#" + tab_id).addClass("active");
});

// custom accordion
$(function () {
	var Accordion = function (el, multiple) {
		this.el = el || {};
		this.multiple = multiple || false;

		var links = this.el.find(".tab-click");
		links.on( "click", {
				el: this.el,
				multiple: this.multiple,
			},
			this.dropdown
		);
	};

	Accordion.prototype.dropdown = function (e) {
		var $el = e.data.el;
		($this = $(this)), ($next = $this.next());

		$next.slideToggle();
		$this.parent().toggleClass("active");

		if (!e.data.multiple) {
			$el.find(".tab-content")
				.not($next)
				.slideUp()
				.parent()
				.removeClass("active");
		}
	};
	var accordion = new Accordion($(".accordionwrapp"), false);
});

$(function () {
	var text1 = $("#text1").val();
	var text2 = $("#text2").val();
	var text3 = $("#text3").val();
	var text4 = $("#text4").val();
	$(".typed").typed({
		strings: [text1, text2, text4, text3],
		stringsElement: null,
		typeSpeed: 150,
		startDelay: 1200,
		backSpeed: 20,
		backDelay: 2200,
		loop: true,
		loopCount: 5,
		showCursor: false,
		cursorChar: "|",
		attr: null,
		contentType: "html",
		callback: function () {},
		preStringTyped: function () {},
		onStringTyped: function () {},
		resetCallback: function () {},
	});
});

$(".postionoverimg span").click(function () {
	$(".postionoverimg").removeClass("active");
	$(this).parent("p").toggleClass("active");
});

$(".jarallax").jarallax({
	speed: 0.5,
});

$(document).ready(function () {
	var heightbanner = $(".product-new-banner").outerHeight();
	var previousScroll = heightbanner;
	$(window).scroll(function (event) {
		var scroll = jQuery(this).scrollTop();
		if (scroll > previousScroll) {
			$(".fixed-product-bottomm").addClass("active");
			$(".fixed-product-bottomm").removeClass("scrolldown");
		} else {
			$(".fixed-product-bottomm").addClass("scrolldown");
			$(".fixed-product-bottomm").removeClass("active");
		}
		previousScroll = scroll;
	});

	$(window).scroll(function () {
		var heightbanner = $(".product-new-banner").outerHeight();
		if ($(window).scrollTop() < heightbanner) {
			$(".fixed-product-bottomm").removeClass("active");
			$(".fixed-product-bottomm").removeClass("scrolldown");
		}
	});
});

$(document).ready(function () {
	const video = document.getElementById("video");
	const long = document.getElementById("trigger");
	let scrollpos = 0;
	let lastpos;
	const controller = new ScrollMagic.Controller();
	const scene = new ScrollMagic.Scene({
		triggerElement: long,
		triggerHook: "0.5",
	});
	const startScrollAnimation = () => {
		if (long) {
			scene
			.addTo(controller)
			.duration(long.clientHeight)
			.on("progress", (e) => {
				scrollpos = e.progress;
			});

			setInterval(() => {
				if (lastpos === scrollpos) return;
				requestAnimationFrame(() => {
					video.currentTime = video.duration * scrollpos;
					video.pause();
					lastpos = scrollpos;
				});
			}, 50);
		}
	};
	const preloadVideo = (v, callback) => {
		const ready = () => {
			v.removeEventListener("canplaythrough", ready);

			video.pause();
			var i = setInterval(function () {
				if (v.readyState > 3) {
					clearInterval(i);
					video.currentTime = 0;
					callback();
				}
			}, 50);
		};
		if (v) {
			v.addEventListener("canplaythrough", ready, false);
			v.play();
		}
	};

	preloadVideo(video, startScrollAnimation);

	startScrollAnimation();
});

$(".btn_bottom").click(function (evt) {
	evt.preventDefault();
	console.log("Clicked");
	$(".product-form__cart-submit").trigger("click");
	// Do here whatever you want
});

$(".btn-sticky-atc").click(function (evt) {
	evt.preventDefault();
	//$(".product-form__variants [data-add-to-cart]").trigger("click");
	$(".product-form__cart-submit").trigger("click");
	// Do here whatever you want
});

$("[data-atc-sticky]").click(function (evt) {
	evt.preventDefault();
  console.log('trigger atc click');
	$("[data-add-to-cart]").trigger("click");	
});


if ($(window).width() < 1200 && $(window).width() > 768) {
	gsap.timeline({
		scrollTrigger: {
			trigger: ".product-new-banner .custom-img-box",
			start: "top 20%",
			scrub: true,
			pin: ".product-new-banner .custom-img-box-fixed",
			anticipatePin: 1,
		},
	});
}

// Needs to be on global scope
var currentURL = window.location.href.split('/')
var isOurStory = currentURL[currentURL.length - 1] === 'our-story';

if (isOurStory) {

	var player_id = fetchVideoId();
	var tag = document.createElement("script");
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName("script")[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	window.player;

	window.onYouTubeIframeAPIReady = function () {
		console.log("its happening");
		player = new YT.Player("player", {
			height: "390",
			width: "640",
			videoId: player_id,
			events: {
				onReady: onPlayerReady,
				onStateChange: onPlayerStateChange,
			},
		});
	};

	window.onPlayerReady = function (event) {
		// console.log('player ready')
	};

	window.done = false;
	window.onPlayerStateChange = function (event) {
		// console.log("hello");
	};
	window.stopVideo = function () {
		player.stopVideo();
	};

	window.playVideo = function () {
		player.playVideo();
	};

}


var fa15_accent = document.querySelector(".img__accent");
var is_mobile = function() {
	return window.innerWidth <= 768;
}
if (fa15_accent) {
	var original_viewbox = fa15_accent.getAttribute("viewBox");

	if (fa15_accent && is_mobile()) {
		fa15_accent.setAttribute("viewBox", "500 0 166 75");
	}

	window.addEventListener("resize", function () {
		console.log(is_mobile());
		if (!is_mobile()) {
			console.log("inside");
			fa15_accent.setAttribute("viewBox", original_viewbox);
		}
	});
}

// Search drawer
$(document).ready(function () {

	var SearchDrawer = function(element) {
		var container = element;

		var drawer = container.querySelector("#SearchDrawer");
		var drawerInput = container.querySelector(".search-form__input");
		var drawerForm = container.querySelector("form");
		var suggestionBar = container.querySelector(".search-bar__suggestions ul");
		var triggers = []
		var state = {
			isOpen: false
		}

		var isButton = function(element) {
			return element.tagName.toLowerCase() === "button"
		};

		addListeners();

		function addListeners() {
			suggestionBar.addEventListener('click', searchForTerm)
			document.addEventListener('click', handleOutside)
		}

		function handleOutside(e) {
			if (!state.isOpen) return
			var isModalClicked = drawer.contains(e.target)
			if (!isModalClicked) closeDrawer()
		}

		function insertSearchTerm(term) {
			drawerInput.value = term;
		}

		function submitForm() {
			drawerForm.submit()
		}

		function searchForTerm(e) {
			if (!isButton(e.target)) return;
			var value = e.target.children[0].innerHTML; // This line is expecting a single span in the button
			insertSearchTerm(value);
			submitForm()
		}

		function addTrigger(el) {
			triggers.push(el)
			el.addEventListener("click", toggleDrawer);
		}

		function toggleDrawer() {
			container.classList.contains("is-active")
				? closeDrawer()
				: openDrawer();
		}

		function openDrawer() {
			container.classList.add("is-active");
			document.body.classList.add("no-scroll");
			setTimeout(function() {
				container.classList.add("is-animated");
				state.isOpen = true;
			}, 150)
		}

		function closeDrawer() {
			container.classList.remove("is-animated");
			document.body.classList.remove("no-scroll");
			setTimeout(function () {
				container.classList.remove("is-active");
				state.isOpen = false
			}, 500);
		}

		return {
			addTrigger
		}
	}

	if (theme.settings.searchEnabled) {
		var drawer = document.querySelector("#shopify-section-search-drawer");
		if (!drawer) return

		var searchDrawer = SearchDrawer(drawer);
		const triggers = [].slice.call(document.querySelectorAll(".search-drawer--trigger"));
		triggers.forEach(function (trigger) {
			searchDrawer.addTrigger(trigger);
		});
		searchDrawer.addTrigger(document.querySelector(".search-bar__close"));
	}

})

$(document).ready(function () {

	var PredictiveSearch = function(element) {
		var searchInput = element.querySelector(".search-form__input");
		var suggestionContainer = element.querySelector('.predictive-search-wrapper');
		var hasFocus = false;
		var hasInput = false;

		addListeners()

		function addListeners() {
			searchInput.addEventListener("input", displayDropdown);
			searchInput.addEventListener("focus", handleFocus);
			searchInput.addEventListener("focusout", handleFocus);
		}

		function handleFocus({ target }) {
			hasFocus = target === document.activeElement;
			if (hasFocus && hasInput) {
				enableResults()
			} else {
				setTimeout(function() {
					disableResults();
				}, 200)
			}
		}

		function enableResults() {
			suggestionContainer.classList.add("active");
		}

		function disableResults() {
			suggestionContainer.classList.remove('active')
		}

		function clearDropdown() {
			suggestionContainer.innerHTML = "";
		}

		function checkInput(input) {
			const conditions = ['', null, undefined]
			return !conditions.some(function(condition) {
				return input === condition
			})
		}

		async function fetchResults(term) {
			var response = await fetch(`/search/suggest.json?q=${term}&resources[type]=product,page,article,collection`);
			var suggestions = await response.json()
			if (suggestions.status === 422 || suggestions.resources.results <= 0) {
				return [];
			}
			return suggestions.resources.results;
		}

		async function displayDropdown({target}) {
			hasInput = checkInput(target.value)
			if (!hasInput) {
				disableResults();
				clearDropdown();
				return;
			};

			const results = await fetchResults(target.value);
			const hasResults = Object.keys(results).some(function(list) {
				return results[list].length;
			});

			if (!hasResults || !hasFocus) {
				disableResults();
				clearDropdown();
				return
			}

			enableResults()

			const html = [
				...Object.keys(results).flatMap(function (category) {
					return results[category].map(function (result) {
						return `<li><a href='${result.url}'>${result.title}</a></li>`;
					});
				}),
			];

			suggestionContainer.innerHTML = html.join("");
		}
	}

	if (theme.settings.predictiveSearchEnabled) {
		var searchForm = document.querySelector(".search-form");
		if (searchForm) {
			searchForm && PredictiveSearch(searchForm);
		}
	}
})

$(document).ready(function () {
	// Add active link class to menu
	var ActiveLinkRenderer = function(element, activeClassName) {
		var navigation = element;
		var activeClass = activeClassName;
		var host = window.location.host;
		var page_path = window.location.pathname;
		var navigation_links = navigation.querySelectorAll('a');

		navigation_links.forEach(function(link){
			var link_path = link.href.split(host)[1];
			if (page_path === link_path) link.classList.add(activeClass);
		})
	}

	var account_navigation = document.querySelector(".account__navigation");
	if (!account_navigation) return
	ActiveLinkRenderer(account_navigation, "account__navigation__link--active");
})

$(document).ready(function () {
	var toggle = document.querySelector("#btn-referral-toggle-launcher");
	var referral_widget = document.querySelector("#refcandy-poprocks");

	if (!toggle || !referral_widget) return;

	setTimeout(function() {
		gsap.set("#refcandy-poprocks > div", {
			rotate: "0deg"
		});
		gsap.to("#refcandy-poprocks", {
			opacity: 1,
			delay: 1.5,
			duration: 1
		});
	}, 3000)
	toggle.addEventListener('click', function() {
		gsap.to("#refcandy-poprocks > div", {
			duration: 0.1,
			rotate: '5deg',
			force3D: false,
			ease: "sine.in",
		});
		gsap.to("#refcandy-poprocks > div", {
			duration: 0.1,
			rotate: "-5deg",
			force3D: false,
			ease: "sine.out",
			delay: 0.1,
		});
		gsap.to("#refcandy-poprocks > div", {
			duration: 0.1,
			rotate: "0deg",
			force3D: false,
			ease: "sine.out",
			delay: 0.2,
		});
	})
})

// CAROUSEL
$(document).ready(function () {

	function mod(n, m) {
		return ((n % m) + m) % m;
	}

	function readableIndex(index) {
		return index + 1;
	}

	var ATTR = {
		CAROUSEL: "carousel",
		NAVIGATION: "navigation",
		NAVIGATION_BTN: "carousel__navigation__btn",
		SLIDE: "carousel__slide",
		SLIDE_ACTIVE: "carousel__slide--active",
		SLIDE_ACTIVE_TRANSITION: "carousel__slide--transition",
		INDICATOR: "indicator",
		INDICATOR_CURRENT: "indicator--current",
		INDICATOR_TOTAL: "indicator--total",
	};

	var Carousel = function(element) {

		var index = 0;
		var transitionTime = 750; // ms
		var root = element
		var navigation = root.querySelector(`.${ATTR.NAVIGATION}`)
		var slides = [].slice.call(carousel.querySelectorAll(`.${ATTR.SLIDE}`));
		var slidesNum = slides.length;
		var activeSlide = root.querySelector(`.${ATTR.SLIDE_ACTIVE}`);
		var toAnimate = true;
		var timeBetweenSlides = root.getAttribute("data-transition-time") * 1000 || false;

		// Not in use
		// var indicator = root.querySelector(`.${ATTR.INDICATOR}`)
		// var indicatorCurrent = indicator.querySelector(`.${ATTR.INDICATOR_CURRENT}`);
		// var indicatorTotal = indicator.querySelector(`.${ATTR.INDICATOR_TOTAL}`);

		// Initialize Indicator
		// indicatorCurrent.innerHTML = readableIndex(index);
		// indicatorTotal.innerHTML = slidesNum;

		var touchstartX = 0;
		var touchstartY = 0;
		var touchendX = 0;
		var touchendY = 0;


		function handleGesture(touchstartX, touchstartY, touchendX, touchendY) {
			const delx = touchendX - touchstartX;
			const dely = touchendY - touchstartY;

			if (Math.abs(delx) > Math.abs(dely)) {
				if (delx > 10) {
					prevSlide()
					toAnimate = false;
				} else if (delx < -10) {
					nextSlide();
					toAnimate = false;
				}
			} else return "tap";
		}

//       	customLinks()
		events()
		play()

        function customLinks() {
	      	var links = [].slice.call(root.querySelectorAll('.carousel__slide--hotspot .carousel__description a, .carousel__slide--hotspot .carousel__description [href]'));
          console.log(links.length)
            if (links.length) {
              for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
              if (links[i].hostname !== window.location.hostname) {
                links[i].target = '_blank';
                links[i].relList.add('noreferrer', 'noopener');
              }
            }
          }
        }


		function play() {
			animate()
		}

		function animate() {
			if (timeBetweenSlides <= 0) return;

			setTimeout(function () {
				if (toAnimate) {
					nextSlide();
					animate();
				}
			}, timeBetweenSlides);
		}

		function events() {
			navigation.addEventListener("click", handleClick);

          		root.addEventListener("touchstart", function (event) {
				touchstartX = event.changedTouches[0].screenX;
				touchstartY = event.changedTouches[0].screenY;
				},
				false
			);

		root.addEventListener("touchend", function (event) {
			touchendX = event.changedTouches[0].screenX;
			touchendY = event.changedTouches[0].screenY;

			handleGesture(touchstartX, touchstartY, touchendX, touchendY);
		}, false);
		}

		function handleClick(e) {
			if (!e.target.classList.contains(ATTR.NAVIGATION_BTN)) return;
			var direction = e.target.getAttribute('data-direction');
			toAnimate = false;

			switch (direction) {
				case 'prev':
					prevSlide()
					break;
				case 'next':
					nextSlide()
					break;
				default:
					console.log('ERROR...Check Direction')
			}
		}

		function nextSlide() {
			index = mod((index + 1), slidesNum);
			changeCurrentSlide(index);
		}

		function prevSlide() {
			index = mod(index - 1, slidesNum);
			changeCurrentSlide(index);
		}

		function delay(ms, payload) {
			return new Promise(function (resolve) {
				setTimeout(function () {
					resolve(payload);
				}, ms);
			});
		}

		function changeCurrentSlide(index) {
			delay(0)
				.then(function() {
					activeSlide.classList.remove(ATTR.SLIDE_ACTIVE_TRANSITION);
					return delay(transitionTime);
				}).then(function() {
					// changeCurrentIndicator(index);
					activeSlide.classList.remove(ATTR.SLIDE_ACTIVE);
					slides[index].classList.add(ATTR.SLIDE_ACTIVE);
					slides[index].classList.add(ATTR.SLIDE_ACTIVE_TRANSITION);
					activeSlide = slides[index];
				})
		}

		// function changeCurrentIndicator() {
		// 	indicatorCurrent.innerHTML = readableIndex(index);
		// }

		return {
			element
		}
	}

	var carousel = document.querySelector(`.${ATTR.CAROUSEL}`)
    if (carousel) {
      var heroCarousel = Carousel(carousel);
    }

})
